import * as api from '@utils/api'
import { FeaturedItemList, FeaturedItemSelection } from '@types'

export const getFeaturedItems = async (): Promise<FeaturedItemList> => {
  const response = await api.GET('/p4/featured')

  return response.data
}

export const setFeaturedItems = async (
  featuredItems: FeaturedItemSelection[],
): Promise<FeaturedItemList> => {
  const response = await api.PUT('/p4/featured', { items: featuredItems })

  return response.data
}
